import { render } from "./yard.vue?vue&type=template&id=6a0b4b15&scoped=true"
import script from "./yard.vue?vue&type=script&lang=js"
export * from "./yard.vue?vue&type=script&lang=js"

import "./yard.vue?vue&type=style&index=0&id=6a0b4b15&lang=css"
import "./yard.vue?vue&type=style&index=1&id=6a0b4b15&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0b4b15"]])

export default __exports__